import { render, staticRenderFns } from "./NewsletterElement.vue?vue&type=template&id=850066aa&scoped=true&"
import script from "./NewsletterElement.vue?vue&type=script&lang=js&"
export * from "./NewsletterElement.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterElement.vue?vue&type=style&index=0&id=850066aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850066aa",
  null
  
)

export default component.exports